import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-50945c95"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "relative h-full w-5xl px-10 mx-auto xl:px-5" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "absolute top-1/4 h-1/2 bg-dots bg-no-repeat bg-cover right-0 md:-right-4 lg:w-40 md:w-30 sm:w-20 opacity-50" }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "absolute top-1/4 h-1/2 bg-dots bg-no-repeat bg-cover left-0 md:-left-4 lg:w-40 md:w-30 sm:w-20 opacity-50" }, null, -1))
const _hoisted_4 = { class: "flex flex-col py-10 md:space-y-0 md:space-x-5 lg:w-2/3 md:w-10/12 mx-auto xs:my-auto" }
const _hoisted_5 = { class: "py-3 text-2xl md:text-5xl text-red-600 rtl:font-cairo font-oswald font-semibold" }
const _hoisted_6 = { class: "mx-auto py-5 w-full text-xl md:text-xl lg:text-2xl lg:rtl:text-xl text-gray-800 rtl:font-cairo font-oswald font-light" }
const _hoisted_7 = { class: "flex justify-center items-center md:w-11/12 lg:w-full py-5" }
const _hoisted_8 = { class: "flex flex-col items-start justify-center space-y-5 md:space-x-10 rtl:space-x-reverse rtl:font-cairo font-oswald text-red-500 text-2xl rtl:text-xl md:flex-row md:items-center" }
const _hoisted_9 = { class: "flex flex-row items-center justify-center space-x-5 rtl:space-x-reverse" }
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "mt-4 mb-2" }
const _hoisted_12 = { class: "flex flex-row items-center justify-center space-x-5 rtl:space-x-reverse" }
const _hoisted_13 = ["src"]
const _hoisted_14 = { class: "mt-4 mb-2" }
const _hoisted_15 = { class: "flex flex-row items-center justify-center space-x-5 rtl:space-x-reverse" }
const _hoisted_16 = ["src"]
const _hoisted_17 = { class: "mt-4 mb-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("h1", _hoisted_5, _toDisplayString(_ctx.$t('services.title')), 1),
      _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t('services.content')), 1),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("img", {
              class: "w-16",
              src: require(`../../public/img/about/video.png`),
              alt: "Video production jump sa"
            }, null, 8, _hoisted_10),
            _createElementVNode("h2", _hoisted_11, _toDisplayString(_ctx.$t('nav.video')), 1)
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("img", {
              class: "w-16",
              src: require(`../../public/img/about/motion.png`),
              alt: "Motion graphics jump sa"
            }, null, 8, _hoisted_13),
            _createElementVNode("h2", _hoisted_14, _toDisplayString(_ctx.$t('nav.motion')), 1)
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("img", {
              class: "w-16",
              src: require(`../../public/img/about/branding.png`),
              alt: "Branding jump sa"
            }, null, 8, _hoisted_16),
            _createElementVNode("h2", _hoisted_17, _toDisplayString(_ctx.$t('nav.branding')), 1)
          ])
        ])
      ])
    ])
  ]))
}